import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';

import fetchQuery from 'rebook/apps/utils/fetchQuery';
import { pop } from 'rebook/apps/users/actions/NotificationActions';
import uaDetector from 'rebook/apps/utils/uaDetector';
import MyShelves from 'rebook/apps/books/components/MyShelves';
import ModalDialog from 'rebook/mybook/App/ModalDialogs/ModalDialog';

import NewShelveDialog from 'rebook/apps/books/components/NewShelveDialog';

import styles from './style.scss';


class BookStatusChangePopup extends React.Component {
  constructor(props) {
    super(props);
    const title = this.props.bookTitle.length > 25 ? `${this.props.bookTitle.substr(0, 19)}...` : this.props.bookTitle;
    this.isAudioBook = props.bookType === 'audio';
    this.state = {
      readingStatus: props.readingStatus,
      makeNewShelve: props.makeNewShelve,
      modalWindow: null,
      response: null,
      removeBookFromTheShelve: true,
    };
    this.handleCloseModalWindow = this.handleCloseModalWindow.bind(this);
    this.statusMessages = {
      0: {
        message: `${this.isAudioBook ? 'Аудиокнига' : 'Книга'} ${title} удалена из Моих книг`,
        type: 'removed',
      },
      1: {
        message: `${this.isAudioBook ? 'Аудиокнига' : 'Книга'} ${title} перемещена в список \
         "Хочу ${this.isAudioBook ? 'прослушать' : 'прочитать'}"`,
        type: 'transfered',
        GALabel: this.isAudioBook ? 'WantToListen' : 'WantToRead',
      },
      2: {
        message: `${this.isAudioBook ? 'Аудиокнига' : 'Книга'} \
          ${title} перемещена в список "${this.isAudioBook ? 'Слушаю' : 'Читаю'}"`,
        type: 'thumbsUp',
        GALabel: this.isAudioBook ? 'Listening' : 'Reading',
      },
      3: {
        message: `Поздравляем! Вы ${this.isAudioBook ? 'прослушали' : 'прочитали'} книгу ${title}`,
        type: 'read',
        GALabel: this.isAudioBook ? 'Listened' : 'Read',
      },
    };
  }
  componentDidMount() {
    const { user } = this.props;

    const url = `/api/bookshelf/?user=${user.id}`;
    const params = {
      apiVersion: 3,
      method: 'GET',
    };
    fetchQuery(url, params).then((response) => {
      this.setState({ response: response });
    }).catch(() => {
    });
  }

  onChangeStatus(status) {
    const { bookId } = this.props;
    const url = '/api/bookuserlist/';
    const params = {
      json: {
        book: `/api/books/${bookId}/`,
        readinglist: status,
      },
      apiVersion: 4,
      method: 'POST',
    };
    fetchQuery(url, params).then(() => {
      const { message, type, GALabel } = this.statusMessages[status];
      this.props.pop(message, type);
      ga('send', 'event', this.props.GACategory, 'ChangeStatus', GALabel);
    }).then(() => {
      this.setState({ readingStatus: status });
    }).then(() => {
      this.props.onChangeStatus(status);
    }).catch(() => {
      this.onChangeStatusError();
    });
  }

  onRemoveStatus() {
    const { bookId } = this.props;
    const url = `/api/books/${bookId}/remove-from-books/`;
    const params = {
      apiVersion: 4,
      method: 'DELETE',
    };
    fetchQuery(url, params).then(() => {
      const { message, type } = this.statusMessages[0];
      this.props.pop(message, type);
      ga('send', 'event', 'DeleteFromMyBooks');
    }).then(() => {
      this.props.onChangeStatus(0);
    }).catch(() => {
      this.onChangeStatusError();
    });
  }

  onChangeStatusError() {
    return this.props.pop('Что-то пошло не так', 'error');
  }

  addBookToTheShelve() {
    this.setState({ modalWindow: true, removeBookFromTheShelve: false });
  }

  removeBookFromTheShelve() {
    this.setState({ modalWindow: true, removeBookFromTheShelve: true });
  }

  handleCloseModalWindow() {
    this.setState({ modalWindow: null });
    document.querySelector('body').classList.remove('isNotScrollable');
  }

  shelveDialog(shelveExist) {
    const { response, removeBookFromTheShelve } = this.state;
    const shelveSelection = shelveExist ?
      (<MyShelves
        {...this.props}
        response={response}
        removeBookFromTheShelve={removeBookFromTheShelve}
        gaEventLabel={'BookPage'}
        closeModal={this.handleCloseModalWindow} />) :
      (<NewShelveDialog
        {...this.props}
        gaEventLabel={'BookPage'}
        response={response}
        closeModal={this.handleCloseModalWindow} />);
    return (
      <ModalDialog onClose={() => {
        this.handleCloseModalWindow();
      }} dialog={
        {
          id: '1',
          extraClassName: 'jest-shelveDialog-window',
          emojiIcon: '',
          title: '',
          content:
          shelveSelection,
        }
      } />
    );
  }

  render() {
    const { extraClassName, top, left, bottom, right, isBookOnAnyShelve, shelveExist } = this.props;
    const popupStyle = { top, left, bottom, right };
    const modalWindow = this.shelveDialog(this.props.bookDetail.userBookshelfList.length > 0 || shelveExist);
    return (
      <div className={classNames(styles.container, extraClassName)} style={popupStyle}>
        <div className={styles.isBookInReadingList}>
          <button
            className={classNames(styles.button, { [`${styles.buttonActive}`]: this.state.readingStatus === 1 })}
            onClick={() => this.onChangeStatus(1)}>
            <i className={classNames(styles.icon, styles.iconWant)} />
            <span className={styles.label}>Хочу <br /> {this.isAudioBook ? 'прослушать' : 'прочитать'}</span>
          </button>
          <button
            className={classNames(styles.button, { [`${styles.buttonActive}`]: this.state.readingStatus === 2 })}
            onClick={() => this.onChangeStatus(2)}>
            <i className={classNames(styles.icon, styles.iconReading)} />
            <span className={styles.label}>{this.isAudioBook ? 'Слушаю' : 'Читаю'}</span>
          </button>
          <button
            className={classNames(styles.button, { [`${styles.buttonActive}`]: this.state.readingStatus === 3 })}
            onClick={() => this.onChangeStatus(3)}>
            <i className={classNames(styles.icon, styles.iconRead)} />
            <span className={styles.label}>{this.isAudioBook ? 'Прослушано' : 'Прочитано'}</span>
          </button>
        </div>
        {this.state.modalWindow ? modalWindow : null}
        <button
          className={classNames(styles.button, styles.buttonFunctional)}
          onClick={() => this.addBookToTheShelve()}>
          <span className={styles.labelRemove}>Добавить на полку</span>
          <i className={classNames(styles.icon, styles.iconAdd)} />
        </button>
        {isBookOnAnyShelve ?
          <button
            className={classNames(styles.button, styles.buttonFunctional)}
            onClick={() => this.removeBookFromTheShelve()}>
            <span className={styles.labelRemove}>Удалить из полки</span>
            <i className={classNames(styles.icon, styles.iconRemoveMinus)} />
          </button> :
          null}
        <button
          className={classNames(styles.button, styles.buttonFunctional)}
          onClick={() => this.onRemoveStatus(0)}>
          <span className={styles.labelRemove}>Удалить из моих книг</span>
          <i className={classNames(styles.icon, styles.iconRemove)} />
        </button>
        {!uaDetector.isMobile(window.navigator.userAgent)
          ? (
            <span className={classNames(styles.corner, 'bubbleCorner')} />
          )
          : null
        }
      </div>
    );
  }
}

BookStatusChangePopup.propTypes = {
  bookType: PropTypes.string,
  readingStatus: PropTypes.number,
  bookTitle: PropTypes.string,
  bookId: PropTypes.number,
  top: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  right: PropTypes.string,
};

BookStatusChangePopup.defaultProps = {
  bookType: 'text',
  readingStatus: 0,
  bookTitle: '',
  bookId: 0,
  top: 'auto',
  bottom: 'auto',
  left: 'auto',
  right: 'auto',
};

function mapStateToProps(state) {
  return {
    bookDetail: state.bookDetail,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pop: (message, type) => dispatch(pop(message, type)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookStatusChangePopup);
